import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    powerFlowDirection: Port.powerFlowDirection.literals.output,
}).default({});

const HydroBase = z.object({
    type: z.literal('hydro').default('hydro'),
    electrical: z
        .object({
            ports: z.tuple([port]).default([undefined]),
        })
        .default({}),
});

export const HydroValidator = ComponentValidator.merge(HydroBase);
export const HydroPayloadValidator = ComponentPayloadValidator.merge(HydroBase);

export const HydroDefinition: ComponentDefinition = {
    type: 'hydro',
    name: 'Hydro',
    plural: 'Hydro',
    indicator: 'HYDRO',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: true,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['output'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: HydroValidator,
        payload: HydroPayloadValidator,
    },
};

export type Hydro = z.infer<typeof HydroValidator>;
export type HydroPayload = z.infer<typeof HydroPayloadValidator>;
